import { Zoom } from "react-awesome-reveal";

export default function ContactImg() {
  return (
    <Zoom>
      <img
        src={`imgs/contact.png`}
        alt={`imgs/contact.png`}
        className="max-sm:hidden"
        draggable={false}
      />
    </Zoom>
  );
}
